import { ValueOfKey } from '../../utils-types';

// backend FoodType.foodTypeLabel - the `/foods/:type` route and API path segment, and the legacy
// `/add-food/:type` links, which compare it case-sensitively
export const FOOD_TYPE = {
  CORE: 'core',
  SUPPLEMENT: 'supplement',
  VEGGIES: 'veggies',
  BARCODE: 'barcode',
} as const;

export type FoodType = ValueOfKey<typeof FOOD_TYPE>;

// backend FoodType.name() as returned inside food payloads - never interchangeable with FOOD_TYPE
export const API_FOOD_TYPE = {
  CORE: 'CORE',
  SUPPLEMENT: 'SUPPLEMENT',
  VEGGIES: 'VEGGIES',
  ANONYMOUS_ADDED_BY_USER: 'ANONYMOUS_ADDED_BY_USER',
  RECIPES: 'RECIPES',
  BARCODE: 'BARCODE',
  FAST_FOOD: 'FAST_FOOD',
} as const;

export type ApiFoodType = ValueOfKey<typeof API_FOOD_TYPE>;
